module.exports = __webpack_public_path__ + "static/img/homeNavigation3.f4e96f8d.png";